import * as React from "react";
import {Button, Form, Table, Alert, Badge} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CreateOrderPosition, VinQueryDetails } from "../../../../../stores";
import { formatMoney } from "../../../../../common/Formatting";
import { wrapCheckbox, wrapInput } from "../../../../../common/FormChangeWrapper";
import { EditableText } from "../../../../../common/UI/EditableText";


interface IProps {
    positions: CreateOrderPosition[];
    vinQuery?: VinQueryDetails;
    hideCommercialFields: boolean;
    onPositionChecked: (uuid: string, checked: boolean) => void;
    onAllPositionChecked: (checked: boolean) => void;
    removePosition: (uuid: string) => void;
    openAddPositionModal: (vinPositionId?: number) => void;
    changePositionCount: (uuid: string, newCount: number) => void;
    changeComment: (uuid: string, comment: string) => void;
    moveRow: (rowNumber: number, direction: "up" | "down") => void;
}



export const ProductsTableComponent: React.StatelessComponent<IProps> = (props) => {

    const changeCommentByButton = (uuid: string, comment: string, text: string) => {
        if (comment !== "") {
            text = " " + text.toLowerCase();
        }
        props.changeComment(uuid, comment + text);
    };

    const renderRow = (w: CreateOrderPosition, uuid: string, index: number) => {

        let refundInfo = <Badge variant="success" title={`Обратный выкуп ${w.refundDiscount === 0 ? 'без уценки' : 'c уценкой ' + w.refundDiscount + '%'}`}>
            {w.refundDiscount === 0 ? <FontAwesomeIcon icon="check"/> : w.refundDiscount}
        </Badge>

        if (w.isAllowDiscountRefund == null) {
            refundInfo = <div></div>
        } else {
            if (!w.isAllowDiscountRefund) {
                refundInfo = <Badge variant="warning" title="Обратный выкуп невозможен">
                    <FontAwesomeIcon icon="times"/>
                </Badge>
            }
        }

        const supCodeMatch = w.supName.match(/\{([^}]+)}/);
        const supCode = supCodeMatch ? supCodeMatch[1] : null;


        return <tr key={uuid}>
            <td className="text-center">
                <div className="d-flex flex-wrap justify-content-center" style={{gridGap: '0 5px'}}>
                    <big className="font-weight-bold">
                        {index+1}
                    </big>
                    <big>
                        <FontAwesomeIcon icon="angle-up" size="lg" onClick={() => props.moveRow(w.sorting, "up")} style={{ cursor: "pointer" }} />
                        {' '}
                        <FontAwesomeIcon icon="angle-down" size="lg" onClick={() => props.moveRow(w.sorting, "down")} style={{ cursor: "pointer" }} />
                    </big>
                </div>
            </td>
            <td className="text-center">
                <Form.Check type="checkbox"
                    checked={w.isChecked} onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                        props.onPositionChecked(uuid, checked);
                    })} />
            </td>
            <td>{w.brand}</td>
            {!props.hideCommercialFields ?
                <td>{w.article}</td>
                : []
            }
            {!props.hideCommercialFields ?
                <td> {w.description} </td>
                : <td> <EditableText text={w.description || "undefined"} /> </td> // Посмотреть почему text жалуется что может придти не string
            }
            {!props.hideCommercialFields ?
                <td className="text-center">{w.supName}<br/>{refundInfo}</td>
                : <td className="text-center">{supCode}</td>
            }
            <td className="text-center">{w.deliveryTimeString}</td>
            <td style={{ width: 90 }} className="text-center">{w.isInUpdating ? <FontAwesomeIcon icon="spinner" /> : w.timeToRegionString}</td>
            {!props.hideCommercialFields ?
                <td className="text-center">{w.awailableCount}</td>
                : []
            }
            <td className="text-center">
                {w.priceChangedUp && w.newCostSale != undefined ? <span>{formatMoney(w.costSale)}&rarr;<span style={{ color: "red" }}>{formatMoney(w.newCostSale)}</span></span> :
                    w.priceChangedDown && w.newCostSale != undefined ? <span>{formatMoney(w.costSale)}&rarr;<span style={{ color: "green" }}>{formatMoney(w.newCostSale)}</span></span> :
                        formatMoney(w.costSale)}

            </td>
            {!props.hideCommercialFields ?
                <td className={"text-center" + ((w.awailableCount < w.count) ? " table-danger" : "")}>
                    <Form.Control
                        style={{ width: "100px", margin: "0 auto" }}
                        type="number"
                        value={w.count.toString()}
                        onChange={wrapInput((fieldName: string, value: string) => {
                            props.changePositionCount(uuid, parseInt(value))
                        })} />
                </td> :
                <td className="text-center">{w.count}</td>
            }

            <td className="text-center">{formatMoney((w.newCostSale != undefined ? w.newCostSale : w.costSale) * w.count)}</td>
            {!props.hideCommercialFields ?
                <td className="text-center"
                    style={{ color: (w.priceChangedUp || w.notFound) ? "red" : w.priceChangedDown ? "green" : "" }}
                >
                    {w.isInUpdating ? <FontAwesomeIcon icon="spinner" /> : w.relevancyStatus}
                </td>
                : []
            }
            <td style={{ width: "200px" }}>
                <div style={{ position: "relative" }}>
                    <Form.Control type="text" name="comment" value={w.comment} size="sm"
                        onChange={wrapInput((fieldName: string, value: string) => {
                            props.changeComment(uuid, value)
                        })}
                        style={{ paddingRight: "25px" }}
                    />
                    {w.comment && !props.hideCommercialFields ?
                        <Button
                            variant="link"
                            style={{ position: "absolute", right: "1px", top: "50%", transform: "translateY(-50%)",  color: "grey" }}
                            onClick={() => props.changeComment(uuid, "")}
                        > x </Button>
                        : []
                    }       
                </div>
                {!props.hideCommercialFields ?
                    <div className="d-flex justify-content-between w-100 mt-1" style={{ gap: "3px" }}>
                        <Button className="btn-xs flex-grow-1" variant="outline-secondary" onClick={() => changeCommentByButton(uuid, w.comment, "Перед")}> ПЕР </Button>
                        <Button className="btn-xs flex-grow-1" variant="outline-secondary" onClick={() => changeCommentByButton(uuid, w.comment, "Зад")}> ЗАД </Button>
                        <Button className="btn-xs flex-grow-1" variant="outline-secondary" onClick={() => changeCommentByButton(uuid, w.comment, "Левый")}> ЛЕВ </Button>
                        <Button className="btn-xs flex-grow-1" variant="outline-secondary" onClick={() => changeCommentByButton(uuid, w.comment, "Правый")}> ПРВ </Button>
                    </div>
                    : []
                }
            </td>
            {!props.hideCommercialFields ?
                <td className="text-center">
                    <Button className="btn-xs" variant="danger" title="Удалить позицию"
                        onClick={() => props.removePosition(uuid)}>
                        <FontAwesomeIcon icon="times" />
                    </Button>
                </td>
                : []
            }
        </tr>
    }
    const tableRowIndex = 0;

    return <Table striped bordered className="table-xxs" key={2}>
        <thead>
            <tr>
                <th></th>
                <th style={{ width: "50px", textAlign: "center" }}>
                    <Form.Check type="checkbox" checked={props.positions.filter(w => !w.isChecked).length == 0} onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                        props.onAllPositionChecked(checked);
                    })} />
                </th>
                <th>Бренд</th>
                {!props.hideCommercialFields ?
                    <th>Артикул</th>
                    : []
                }
                <th>Описание</th>
                <th>Поставщик</th>
                <th className="text-center">Срок</th>
                <th className="text-center">Клиенту</th>
                {!props.hideCommercialFields ?
                    <th className="text-center">Доступно</th>
                    : []
                }
                <th className="text-center">Цена</th>
                <th className="text-center">Количество</th>
                <th className="text-center">Сумма</th>
                {!props.hideCommercialFields ?
                    <th className="text-center">Статус <br />проценки</th>
                    : []
                }
                <th className="text-center">Комментарий</th>
                {!props.hideCommercialFields ?
                    <th></th>
                    : []
                }
            </tr>
        </thead>
        <tbody>

            {props.vinQuery != undefined && props.vinQuery.items != undefined ?
                props.vinQuery.items.map((ww, index) => {

                    return [
                        <tr key={index}>
                            <th></th>
                            <th>{ww.description}</th>
                            <th>{ww.type}</th>
                            <th colSpan={5}>{ww.comment}</th>
                            <th className="text-center">{ww.count}</th>
                            <th></th>
                            <th></th>
                            <th className="text-center">
                                <Button variant="primary" size="sm"
                                    onClick={() => props.openAddPositionModal(ww.id)}><FontAwesomeIcon icon="search" />{' '}Добавить предложения</Button>
                            </th>
                        </tr>,
                        props.positions.filter(w => w.vinQueryPositionId == ww.id).map((w, index) => {
                            return renderRow(w, w.uuid, index);
                        })
                    ];
                })
                :
                props.positions.sort((a, b) => a.sorting > b.sorting ? 1 : -1).map((w, index) => {
                    return renderRow(w, w.uuid, index);
                })
            }
        </tbody >
        <tfoot>
            <tr>
                <td colSpan={props.hideCommercialFields ? 6 : 9} className="text-right">
                    Итого:
                </td>
                <td className="text-center">
                    <strong>
                        {props.positions.reduce((a: number, b) => a + b.count, 0)}
                    </strong>
                </td>
                <td className="text-center">
                    <strong>
                        {formatMoney(props.positions.reduce((a: number, b) => a + ((b.newCostSale || b.costSale) * b.count), 0))}
                    </strong>
                </td>
                {props.hideCommercialFields ? <td></td> :
                    <td colSpan={4} ></td>
                }

            </tr>
            {props.hideCommercialFields ? <tr>
                <td colSpan={9}>
                    <Alert variant="warning">
                        <a className="alert-link">Внимание!!! Данное Коммерческое предложение по цене и срокам действительно в течении текущего дня!!!</a>
                    </Alert>
                </td>
            </tr>
                : []}
            {props.vinQuery != undefined && props.vinQuery.items != undefined ? [] :
                <tr>
                    <td colSpan={props.hideCommercialFields ? 9 : 14}>
                        <div className="text-right">
                            <Button variant="primary" size="sm" onClick={() => props.openAddPositionModal()}><FontAwesomeIcon icon="search" />{' '}Добавить товары в заказ</Button>
                        </div>
                    </td>
                </tr>
            }
        </tfoot>
    </Table >
}